import api from "@/services/modules/references";
import {
  SET_REFERENCES,
  SET_CURRENT_REFERENCE,
  SET_IS_FETCHING_REFERENCES,
  SET_IS_FETCHING_CURRENT_REFERENCE,
  SET_IS_FETCHING_USER_REFERENCES,
  SET_CURRENT_USER_REFERENCES
} from "./mutations";
import {
  errorHandler,
  handleWithErrorMessage,
  handleWithGlobalMessage
} from "@/services/utils";
import { map } from "lodash";

export const ADD_NEW_REFERENCE = "ADD_NEW_REFERENCE";
export const FETCH_REFERENCES = "FETCH_REFERENCES";
export const DELETE_REFERENCE = "DELETE_REFERENCE";
export const FETCH_CURRENT_REFERENCE = "FETCH_CURRENT_REFERENCE";
export const FETCH_USER_REFERENCES = "FETCH_USER_REFERENCES";
export const UPDATE_USER_REFERENCE = "UPDATE_USER_REFERENCE";
export const APPROVE_REFERENCE = "APPROVE_REFERENCE";
export const REJECT_REFERENCE = "REJECT_REFERENCE";
export const SUBMIT_REFERENCE_FOR_APPROVAL = "SUBMIT_REFERENCE_FOR_APPROVAL";

const actions = {
  async [FETCH_REFERENCES]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api({ commit }).getReferences(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_REFERENCES, isLoading),
      setDataFunction: ({ data }) => commit(SET_REFERENCES, data)
    });
  },
  async [FETCH_CURRENT_REFERENCE]({ commit, dispatch }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api({ commit }).getReference(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_CURRENT_REFERENCE, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_REFERENCE, data)
    });
  },
  async [ADD_NEW_REFERENCE]({ commit, dispatch, state }, newReference) {
    try {
      const { data } = await api({ commit }).addNewReference(newReference);
      commit(SET_REFERENCES, [...state.references, data]);
    } catch (exception) {
      errorHandler(dispatch, exception);
    }
  },
  async [DELETE_REFERENCE]({ commit, dispatch }, id) {
    try {
      await api({ commit }).deleteReference(id);
      return id;
    } catch (exception) {
      errorHandler(dispatch, exception);
    }
  },
  async [FETCH_USER_REFERENCES]({ commit, dispatch }, userId) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api({ commit }).getUserReferences(userId),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_USER_REFERENCES, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_USER_REFERENCES, data)
    });
  },
  async [UPDATE_USER_REFERENCE]({ commit, dispatch }, data) {
    await handleWithGlobalMessage(
      () => api({ commit }).updateUserReference(data),
      dispatch
    );
  },
  async [APPROVE_REFERENCE]({ dispatch, commit }, referenceId) {
    await handleWithGlobalMessage(
      () => api({ commit }).approveReference(referenceId),
      dispatch
    );
  },
  async [REJECT_REFERENCE]({ dispatch, commit }, referenceId) {
    await handleWithGlobalMessage(
      () => api({ commit }).rejectReference(referenceId),
      dispatch
    );
  },
  async [SUBMIT_REFERENCE_FOR_APPROVAL](
    { dispatch, state, commit },
    referenceId
  ) {
    const { data: updatedReference } = await handleWithGlobalMessage(
      () => api({ commit }).submitReferenceForApproval(referenceId),
      dispatch
    );
    const updatedReferences = map(state.references, reference => {
      if (reference.id !== updatedReference.id) return reference;
      return updatedReference;
    });
    commit(SET_REFERENCES, updatedReferences);
  }
};

export default actions;
